import React from "react";
import "./ValorFooter.css";

export default function ValorFooter() {
  const year = new Date().getFullYear();

  return (
    <footer id="support" className="vf-wrap" aria-labelledby="valor-footer-heading">
      <div className="vf-gradient" aria-hidden="true" />

      <div className="vf-inner">
        {/* LEFT: Closing words / mission */}
        <section className="vf-main">
          <p className="vf-kicker">Finish strong. Stand stronger.</p>
          <h2 id="valor-footer-heading" className="vf-title">
            Run with Man of Valor — from Johannesburg to Durban and into every
            home we touch.
          </h2>

          <p className="vf-body">
            Man of Valor is a brotherhood of men choosing courage,
            accountability and service. Every kilometre we cover is a statement
            that men can show up differently — for our families, our streets and
            our country.
          </p>

          <p className="vf-body">
            The 704&nbsp;km Johannesburg&nbsp;→&nbsp;Durban run is more than a
            race. It&rsquo;s a moving declaration of hope, calling men to step
            out of isolation, confront their own brokenness, and stand together
            for safer homes, stronger communities and the next generation
            watching us. Your support helps fuel initiatives that build men up
            and lift communities with them.
          </p>

          <p className="vf-body vf-body-highlight">
            Whether you track the route, share the story, or sow into the
            mission financially — you&rsquo;re running this with us.
          </p>
        </section>

        {/* RIGHT: CTAs & links */}
        <section
          className="vf-actions"
          aria-label="Ways to follow and support Man of Valor"
        >
          {/* Primary tracker card */}
          <article className="vf-card vf-card-primary">
            <div className="vf-pill">Live run · 704&nbsp;km</div>
            <h3 className="vf-card-title">Track the JHB → DBN route live</h3>
            <p className="vf-card-text">
              Watch the team move in real time on the map, follow each stage of
              the journey, and cheer them on from wherever you are.
            </p>
            <a
              className="vf-btn vf-btn-primary"
              href="https://manofvalor-tracking.web.app/"
              target="_blank"
              rel="noreferrer noopener"
            >
              📍 Open live tracker
            </a>
            <p className="vf-card-meta">
              Tip: bookmark the tracker during run week so it&rsquo;s one tap
              away.
            </p>
          </article>

          {/* Support / social grid */}
          <div className="vf-grid">
            <article className="vf-card vf-card-donate">
              <h3 className="vf-card-title">Back the mission</h3>
              <p className="vf-card-text">
                Help fuel the kilometres and the work beyond race day by giving
                through BackaBuddy.
              </p>
              <a
                className="vf-btn vf-btn-ghost"
                href="https://www.backabuddy.co.za/campaign/man-of-valor-jhb-to-dbn-2025"
                target="_blank"
                rel="noreferrer noopener"
              >
                💛 Donate via BackaBuddy
              </a>
            </article>

            <article className="vf-card vf-card-social">
              <h3 className="vf-card-title">Follow the journey</h3>
              <p className="vf-card-text">
                Daily moments, real stories and behind-the-scenes grit as the
                team trains and runs.
              </p>
              <div className="vf-social-links">
                <a
                  href="https://www.instagram.com/manofvalor.official/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="vf-social-pill"
                >
                  <span aria-hidden="true">📸</span>
                  <span>Instagram</span>
                </a>
                <a
                  href="https://www.facebook.com/groups/mov.official/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="vf-social-pill"
                >
                  <span aria-hidden="true">👥</span>
                  <span>Facebook community</span>
                </a>
              </div>
            </article>
          </div>
        </section>
      </div>

      <div className="vf-bottom">
        <p className="vf-bottom-text">
          Thank you for standing with us, kilometre after kilometre.
        </p>
        <p className="vf-bottom-meta">
          © {year} Man of Valor. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
